import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { QuestionBase, QuestionElement } from '../question-base';
import { QuestionFormControlService } from '../services/question-form-control/question-form-control.service';
import { FormValuesService } from '../services/form-values/form-values.service';
import { DynamicQuestions } from '../services/question/question.service';
import { QuestionRow } from '../question-row';
import { isObject } from 'util';
import { Router } from '@angular/router';
import { CustomerEditService } from '../services/customer-edit/customer-edit.service';
import { Subscription } from 'rxjs/Subscription';
import { ApiService } from '../services/api/api.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css', '../test/test.component.css'],
  providers: [ QuestionFormControlService ]
})
export class DynamicFormComponent implements OnChanges {

  // We could use a special input setter here instead of ngOnChanges
  @Input() public questionPage : QuestionRow = null;
  @Output() public onSubmit = new EventEmitter<any>( true );
  @Output() public formValidity = new EventEmitter<any>( true );

  public form: FormGroup;
  private nettoSub : Subscription = null;
  
  ngOnDestroy(): void {
    if( this.nettoSub ){
      this.nettoSub.unsubscribe(); 
    }
  }
  

  constructor(
    private questionFormControlService : QuestionFormControlService,
    private formValueService : FormValuesService,
    private router: Router,
    private customerEditService : CustomerEditService,
    public apiService : ApiService
  ){
    this.nettoSub = this.apiService.calcNetto$.subscribe( ( finishedFunc ) => {
      let nettoRequestObject = {}
      this.questionPage.getQuestionsFlatArr().forEach((elem) => {
        elem.setValue( elem.getLiveValue() );
        nettoRequestObject[elem.key] = elem.getValueForRequest();
      });

      this.apiService.setNettoValues(nettoRequestObject);
      finishedFunc();
    });
  }

  ngOnChanges(ch) {
    if(this.questionPage){
      /*
      for( let key in this.dynamicQuestions.questions ){
        let questionCurrent = this.dynamicQuestions.questions[key];
        if(questionCurrent.uiType === 'row') continue;
        questionCurrent.clearDirty();
      }
      */
     
      this.form = this.questionFormControlService.generateFormGroup(this.questionPage);
      this.form.statusChanges.subscribe(( validityText ) => {
        if( validityText === 'VALID' ){
          this.formValidity.emit(true);
        }else{
          this.formValidity.emit(false);
        }
      });
    }
  }

  public doSubmit() {   
    if( this.router.url.split(';')[0] === "/kundenbearbeitung" ){
      this.customerEditService.dissolveCustomerFormdata(this.questionPage.questions);      
    } else {
      this.questionPage.getQuestionsFlatArr().forEach(( elem : QuestionBase<any> ) => {
        if( elem.hasValue() || elem.getDirty() ){
          elem.setValue( elem.getLiveValue() );

          if( elem.key.substring(0,12) === 'geburtsdatum' && isObject( elem.getValue() ) ){
            let tmp = <any>elem.getValue();
            this.formValueService.setValue( elem.key, tmp.day + '.' + tmp.month + '.' + tmp.year );
            this.formValueService.setValue( elem.key + '_dirty', 1 );
          }else{
            this.formValueService.setValue( elem.key, elem.getValue() );
            this.formValueService.setValue( elem.key + '_dirty', 1 );
          }
        }
      });
      this.onSubmit.emit( 40 );
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/dynamic-form/dynamic-form.component.ts